<template>
    <v-dialog
        v-model="dialog"
        persistent
        style="height: 100%"
    >

        <v-card style="height: 100%">

            <v-card-text style="height: 50%">
                <div class="button-position">
                    <v-btn
                        class="mx-2"
                        fab
                        dark
                        small
                        color="primary"
                        @click="closeModal"
                    >
                        <v-icon dark>
                            mdi-minus
                        </v-icon>
                    </v-btn>
                </div>
                <div>
                    <div class="input-group-style">
                        <label class="label-style">V1 : </label>
                        <input v-model="innerModifySupportModel.versionOne" type="text"
                               placeholder="모델 정보가 없습니다. 입력해주세요"
                               class="border-style-radius input-style"
                        />
                    </div>
                    <div class="input-group-style">
                        <label class="label-style">V2 : </label>
                        <input v-model="innerModifySupportModel.versionTwo" type="text"
                               placeholder="모델 정보가 없습니다. 입력해주세요"
                               class="border-style-radius input-style"
                        />
                    </div>
                    <div class="detail-button-wrapper">
                        <button @click="completeButtonClick" class="button-complete-style">
                            작성완료
                        </button>
                    </div>

                </div>
            </v-card-text>

        </v-card>
    </v-dialog>
</template>

<script>
/**
 * 테이블에서 모델추가 버튼을 클릭시 나오는 컴포넌트입니다.
 * V1과 V2의 supportModel을 가져와 수정을 합니다.
 * 모달을 닫거나 작성완료 버튼을 클릭시 dialog가나와서 사용자의 의사를 체크합니다.
 */
export default {
    name: "PrinterSeriesModelModal",
    data() {
        return {
            innerModifySupportModel:{//내부에서 수정할수 있는 supportModel을 만들었습니다.
                versionOne:undefined,
                versionTwo:undefined
            },

        }
    },
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        tabNumber: { //1은 V1 2는 V2
            type: Number,
            default: 0
        },
        originSupportModel:{//원본데이터
            type:Object,
            default:()=>{}
        },
        modifySupportModel:{//수정한 데이터
            type:Object,
            default:()=>{}
        },
        isDirtyCheck:{//수정하면 false
            type:Object,
            default:()=>{}
        }
    },
    components: {},
    watch: {
        modifySupportModel: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.innerModifySupportModel = newValue
            }
        },
        innerModifySupportModel: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.$emit('change-support-model', newValue)
            }
        },
    },
    methods: {
        /**
         * 모달화면에서 작성하기 버튼을 클릭시 바로 invalid 검사를 하려고
         * 만든 함수입니다.
         */
        invalidSupportModelCheck(){
            function validationCheck(supportModel) {
                const supportModelArr = supportModel.split(",")
                const resultInvalid = supportModelArr.every((supportModel) => {
                    return supportModel[0] !== ' '&& supportModel[supportModel.length-1]!== ' '
                })
                return resultInvalid
            }
            const modelOne = this.innerModifySupportModel.versionOne
            const modelTwo = this.innerModifySupportModel.versionTwo
            const validOne = validationCheck(modelOne)
            const validTwo = validationCheck(modelTwo)
            return !validOne || !validTwo

        },
        /**
         * 모달 상단에 - 버튼 클릭시 동작합니다.
         * 1. 하나라도 수정한 부분이 있으면 dialog 로 의사를 물어봅니다
         * 2. 수정한 부분이 없거나 dialog에서 확인버튼 클릭시 모달을 닫습니다.
         * (단,취소버튼 누를 경우는 앞에 동장을 수행하지 않습니다.)
         */
        closeModal() {
            const dirtyCheck = this.isDirtyCheck && this.isDirtyCheck.versionOne && this.isDirtyCheck.versionTwo
            if (dirtyCheck) {
                this.$emit("close-modal")
            } else {
                this.$confirm("저장하지않고 나가시겠습니까?")
                    .then(() => {
                        this.$emit("close-modal")
                    })
            }
        },
        /**
         * 완료버튼 눌렀을때 동작합니다.
         *  1. 둘다 수정한 부분이 없으면 alert 하나라도 있으면 dialog 로 의사를 물어봅니다
         *  2. dialog에서 확인버튼 누렀을때 invalid검사를 통해 , 앞뒤로 공백이 있는지 체크합니다.
         *  3. 수정한 model만 요청을 보냅니다
         */
        completeButtonClick() {
            const dirtyCheck = this.isDirtyCheck && this.isDirtyCheck.versionOne && this.isDirtyCheck.versionTwo
            if (dirtyCheck) {
                this.$alert("수정된 데이터가 없습니다.")
            } else {
                this.$confirm(`저장하시겠습니까?`)
                    .then(() => {
                        if(this.invalidSupportModelCheck()) {
                            this.$alert(", 앞뒤로 공백을 제거해주세요~!")
                            return
                        }
                        if(!this.isDirtyCheck.versionOne) this.$emit("complete-button-click",0)
                        if(!this.isDirtyCheck.versionTwo) this.$emit("complete-button-click",1)
                        this.$emit("close-modal")
                    })
            }
        },
    }
}
</script>

<style scoped>
.with-full-size{
    width: 100%;
}
.input-group-style{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}
.border-style-radius{
    border:1px solid #cccccc;
    border-radius: 5px;/*스타일 부분으로 내용작 성시 제외*/
}
.label-style{
    font-size: 18px;
    font-weight: bold;
}
.input-style{
    height: 50px;
    width: 97%;
    padding-left: 12px;
}
.button-position{
    text-align: right;
    margin-right: 10px;
    margin-top: 10px;
    margin-bottom: 20px;
}

>>>.v-dialog {
    overflow-y: visible;

}
>>>.v-dialog:not(.v-dialog--fullscreen) {
    max-height: none;

}
>>>.v-dialog .v-card .v-card__text{
    overflow-y: hidden;

}
/*버튼 그룹입니다.*/
.detail-button-wrapper{
    width: 100%;
}
/*작성하기 버튼 부분입니다.*/
.button-complete-style{
    background-color: #42b983 !important;
    border-color: #42b983 !important;
    padding: 6px 0;
    border-radius: 5px;
    width: 100%;
    color: #eeeeee;
    margin-top: 10px;
    margin-right: 20px;
}

</style>